module.exports = __webpack_public_path__ + "img/UserLoginCodes.3e66057a.svg";